<script setup lang="ts">
import {IHeaderParams} from "ag-grid-enterprise";
import EditUiElementPropertiesBtn from "@/components/EditView/EditUIElementPropertiesBtn.vue";
import {ref} from "vue";
import HelpMessage from "@/components/EditView/HelpMessage.vue";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

const props = defineProps<{
  params: IHeaderParams & {
    blockOrField: () => EditScreenGridColumn,
    entityType: string,
    colId: string
  }
}>()
const agHeaderParams = ref<IHeaderParams>({...props.params, displayName: props.params.displayName})

function onTooltipShow() {
  props.params.api.setFocusedCell(0, props.params.column.getColId())
}
</script>
<template>
  <div class="customInnerHeader tw-flex tw-items-center tw-gap-1">
    <EditUiElementPropertiesBtn :agHeaderParams="agHeaderParams" :block-or-field="params.blockOrField()"/>
    <HelpMessage @onTooltipShow="onTooltipShow" v-if="useNamaFlagsStore().showHelpMessagesActive" :entity-type="params.entityType"
                 :field-id="params.colId"/>
    <span class="tw-inline-flex" v-text="useNamaFlagsStore().showIdsActive ? params.colId : params.displayName"/>
  </div>
</template>
